// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Mnwjh","modal":"Modal_modal__A9PZ6","slide-down":"Modal_slide-down__Awxog"};